(function () {
  function loadMnareContactCss() {
    if (document.getElementById("mnare-contact-css")) return;
    var customLink = document.querySelector('link[href*="custom.css"]');
    if (!customLink) return;
    var link = document.createElement("link");
    link.id = "mnare-contact-css";
    link.rel = "stylesheet";
    link.href = customLink.href.replace(/custom\.css/, "mnare-contact.css");
    document.head.appendChild(link);
  }

  function shouldSkipContactRefresh() {
    return !!document.querySelector(
      ".contact__form .form-status__message--success, .contact__form .form-status__message--error"
    );
  }

  function showFormConfirmation() {
    var success = document.querySelector(".contact__form .form-status__message--success");
    if (!success) return;
    var contact = document.querySelector(".contact.section");
    if (contact) contact.classList.add("contact--submitted");
    success.setAttribute("tabindex", "-1");
    success.focus({ preventScroll: true });
    success.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  function refreshContactSection() {
    if (window.location.pathname.replace(/\/$/, "") !== "/pages/contact") return;
    if (shouldSkipContactRefresh()) return;

    loadMnareContactCss();

    var contact = document.querySelector(".contact.section");
    if (!contact) return;

    var marker = document.querySelector(".mnare-contact-marker[data-layout='v7']");
    var layoutOk = marker && contact.classList.contains("contact--centered");

    if (layoutOk) return;

    var wrapper = contact.closest(".shopify-section");
    if (!wrapper || !wrapper.id) return;

    var sectionId = wrapper.id.replace("shopify-section-", "");
    fetch(window.location.pathname + "?section_id=" + encodeURIComponent(sectionId), {
      credentials: "same-origin",
    })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector(".shopify-section");
        if (!fresh) return;
        wrapper.replaceWith(fresh);
        var updated = document.querySelector(".contact.section");
        if (updated) updated.classList.add("is-visible");
      })
      .catch(function () {});
  }

  function showContactSection() {
    var contact = document.querySelector(".contact.section");
    if (contact) contact.classList.add("is-visible");
  }

  function initContactPage() {
    showContactSection();
    showFormConfirmation();
    refreshContactSection();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initContactPage);
  } else {
    initContactPage();
  }
})();
